import React from 'react';
import { CalendarIcon, CheckCircle2Icon } from 'lucide-react';
import { FadeIn } from './FadeIn';
const steps = [{
  week: 'Semana 1 · Observación',
  desc: 'Identificá el hueco. No corrijas, solo observá y anotá lo que ves en las sesiones de tarea.'
}, {
  week: 'Semana 2 · Conexión',
  desc: 'Aplicá el Protocolo del Error, sin presión académica. El objetivo es cambiar la emoción, no el resultado.'
}, {
  week: 'Semana 3 · Práctica Guiada',
  desc: 'Introducí el tema del hueco con los métodos del Tomo 2. Sesiones de 15 minutos máximo.'
}, {
  week: 'Semana 4 · Consolidación',
  desc: 'Repasá y celebrá los avances, sin importar el tamaño. La celebración es parte del aprendizaje.'
}];
export function ActionPlan() {
  return <section className="py-12 md:py-16 bg-background relative" aria-label="Tu plan de acción de 30 días" data-id="element-22">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-23">
        <FadeIn data-id="element-24">
          <div className="text-center mb-8" data-id="element-25">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 mb-4 rounded-full border border-primary/30 bg-primary/10 text-primary-dark text-[10px] md:text-xs font-bold uppercase tracking-widest" data-id="element-26">
              <CalendarIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-27" />
              Tu plan de acción
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-extrabold text-slate-900 mb-3 leading-tight" data-id="element-28">
              Los Próximos 30 Días
            </h2>
            <p className="text-slate-600 max-w-2xl mx-auto text-sm md:text-base leading-snug" data-id="element-29">
              Un camino simple, semana a semana. No necesitás hacerlo perfecto —
              necesitás hacerlo consistente.
            </p>
          </div>
        </FadeIn>

        {/* Vertical timeline */}
        <div className="relative max-w-2xl mx-auto" data-id="element-30">
          {/* connector line */}
          <div className="absolute left-5 md:left-6 top-2 bottom-2 w-0.5 bg-primary/20" aria-hidden="true" data-id="element-31" />
          <ol className="space-y-4" data-id="element-32">
            {steps.map((step, i) => <FadeIn key={i} delay={0.05 + i * 0.08} data-id="element-33">
                <li className="relative flex items-start gap-4 md:gap-5" data-id="element-34">
                  <div className="relative z-10 w-10 h-10 md:w-12 md:h-12 rounded-2xl bg-primary text-white font-heading font-extrabold text-lg md:text-xl flex items-center justify-center shrink-0 shadow-soft" data-id="element-35">
                    {i + 1}
                  </div>
                  <div className="bg-white rounded-2xl border border-slate-100 shadow-soft px-4 py-3 md:px-5 md:py-4 flex-1" data-id="element-36">
                    <h3 className="font-heading text-sm md:text-base font-extrabold text-slate-900 mb-1" data-id="element-37">
                      {step.week}
                    </h3>
                    <p className="text-slate-600 text-xs md:text-sm leading-snug" data-id="element-38">
                      {step.desc}
                    </p>
                  </div>
                </li>
              </FadeIn>)}
          </ol>
        </div>

        <FadeIn delay={0.4} data-id="element-39">
          <div className="mt-8 flex items-start gap-3 bg-primary/[0.07] border border-primary/20 rounded-2xl px-5 py-4 max-w-2xl mx-auto" data-id="element-40">
            <CheckCircle2Icon className="w-5 h-5 text-primary shrink-0 mt-0.5" aria-hidden="true" data-id="element-41" />
            <p className="text-slate-700 text-sm md:text-base leading-snug" data-id="element-42">
              <strong className="text-slate-900 font-bold" data-id="element-43">Recordá:</strong> no
              estás buscando que sea perfecto en 30 días. Estás buscando que
              deje de tenerle miedo.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}